import { ratesFactory, statsHolderFactory, totalsFactory } from '@rtls/core/models/statistics/anomaly.factory';
import { Business } from '@rtls/core/models/statistics/business.model';
import { randomNumber } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const businessFactory = Factory.makeFactory<Business>({
	count: Factory.each(() => randomNumber()),
	stats: Factory.each(() => statsHolderFactory.build()),
	totals: Factory.each(() => totalsFactory.build()),
	rates: Factory.each(() => ratesFactory.build()),
});
